import { api } from 'utility';
import { getInvoiceCrodUrl, postInvoiceProfiletUrl, getInvoiceProfiletUrl, getInvoicePaymentSmsUrl, getInqueryDeligation, getLoanContracts, addUserToContract, postProduct } from 'URLs';
class IssueInvoiceServices {
  async issueInvoice(data) {
    return api.post(getInvoiceCrodUrl(), { preview: false, ...data });
  }
  async invoiceProfile(requestId, data) {
    return api.post(postInvoiceProfiletUrl(requestId), data, {
    }).then((res) => res.data);
  }
  async sendInvoicePaymentSms(data) {
    return api.post(getInvoicePaymentSmsUrl(), data, {
      ignoreCancelToken: true
    }, {
    }).then((res) => res.data);
  }
  async estelamDetails(params) {
    return api.get(getInqueryDeligation(), { params }).then((res) => res.data);
  }

  async getLoanContracts() {
    return api.get(getLoanContracts()).then((res) => res.data);
  }

  async addUserToContract(data, id) {

    return api.post(addUserToContract(id), data, {
    }).then((res) => res.data);
  }

  getInvoiceProfile(params) {
    return api.get(getInvoiceProfiletUrl(), { params }).then((res) => res.data);
  }
  async previewIssueInvoice(data) {
    return api.post(getInvoiceCrodUrl(), { ...data, preview: true });
  }
  async addNewProduct(data) {
    return api.post(postProduct(), { ...data, preview: true });
  }


  async addNewProduct(data) {

    return api.post(postProduct(), data, {
    }).then((res) => res.data);
  }
}

export default new IssueInvoiceServices();
